import React, { Component } from "react";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import routes from "../../routes/URL";
import { Button, TextField, CardContent, CardHeader, Box, Typography, Container } from "@mui/material";
import Toast from "../../components/Toast";
import Header from "../../components/Header"


class UpdateCatagoryScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hall_name: "",
      capacity: "",
      toast: {
        open: false,
        message: "",
        severity: "success"
      }
    };
    console.log("UpdateCatagoryScreen props", this.props.match.params.hall_id);
  }

  componentDidMount() {
    this.getHallDetail(this.props.match.params.hall_id);
  }

  getHallDetail = async (hall_id) => {
    const { status, message, data } = await API(this, "get", URL_PATH.fetchHallDetails(hall_id));
    console.log("data in the hall..", data, "status", status, "message", message);
    console.log("data in the hall", data);
     
    if (status === "success") {
      this.setState({
        hall_name: data.hall_name || "",
        capacity: data.capacity || ""
      });
    } else {
      this.setState({
        toast: {
          open: true,
          message: message,
          severity: "error"
        }
      });
    }
  };

  update = async (hall_id) => {
    const formdata = new FormData(document.getElementById("hotelForm"));
    formdata.append("hall_name", this.state.hall_name);
    formdata.append("capacity", this.state.capacity);
    console.log("formdata", formdata);
console.log("hotwelForm", this.props); // Log the form data
    const { status, message } = await API(
    
      this,
      "post",
      URL_PATH.updateHall(hall_id),
      formdata
    );

    if (status === "success") {
      this.setState({
        toast: {
          open: true,
          message: message,
          severity: "success"
        }
      });
      setTimeout(() => {
        this.props.history.push(routes.admin.halls.list(this.props.hotels[0]?.hotel_slug || ''));
      }, 2000);
    } else {
      this.setState({
        toast: {
          open: true,
          message: message,
          severity: "error"
        }
      });
    }
  };

  render() {
    return (
      <Container maxWidth="lg" className="py-5">
        <Box
          sx={{
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "transparent",
            border: "1px solid #FFC857",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
           <CardHeader
                      title={
                        <Header title="Update Hall" />
          
                      }
                      sx={{ pb: 2 }}
                    />
          <CardContent>
            <form
              id="hotelForm"
              onSubmit={(e) => {
                e.preventDefault();
                this.update(this.props.match.params.hall_id);
              }}
            >
              <Box mb={3}>
                <TextField
                  fullWidth
                  id="hall_name"
                  name="hall_name"
                  label="Hall Name"
                  placeholder="Enter Hall Name"
                  variant="outlined"
                  required
                  value={this.state.hall_name}
                  onChange={(e) => this.setState({ hall_name: e.target.value })}
                  InputProps={{
                    sx: {
                      borderRadius: 1,
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white !important',
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused': {
                        color: 'white !important',
                      },
                    },
                  }}
                />
              </Box>

              <Box mb={3}>
                <TextField
                  fullWidth
                  id="capacity"
                  name="capacity"
                  label="Capacity"
                  placeholder="Enter Capacity"
                  variant="outlined"
                  type="number"
                  value={this.state.capacity}
                  onChange={(e) => this.setState({ capacity: e.target.value })}
                  InputProps={{
                    sx: {
                      borderRadius: 1,
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white !important',
                      },
                      input: {
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused': {
                        color: 'white !important',
                      },
                    },
                  }}
                />
              </Box>

              <Box mt={4} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1,
                    borderRadius: 1,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#FFC857",
                    "&:hover": {
                      bgcolor: "#E6B54E",
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
            </form>
          </CardContent>
        </Box>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={() =>
            this.setState({ toast: { ...this.state.toast, open: false } })
          }
        />
      </Container>
    );
  }
}

export default redux(UpdateCatagoryScreen);
